import SubscribeInput from '../SubscribeInput';
import styles from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { Upto, TopTip } from '@/components/UI/svg/Wave2';

export default function FirstKv() {
    const { useEffect, useLang, isMobile } = useGlobal();
    const { t } = useLang('glacier.teaser.firstKv');

    useEffect(() => {
        if (isMobile) {
            AniContainer.create({
                syncFromTo: [['.firstKv .content-box-container', { y: 0 }, { y: -100 }]],
                triggerElement: '.firstKv .content-box-container',
                triggerHook: 0,
                offset: 0,
                duration: 300,
            });
            return;
        }
        AniContainer.create({
            syncFromTo: [['.firstKv .content-box-container', { y: 0 }, { y: 100 }]],
            triggerElement: '.firstKv',
            triggerHook: 0,
            offset: -700,
            duration: 600,
        });
    }, []);

    return (
        <div className={`${styles.firstKv} firstKv`}>
            <div className="top-tip">
                <TopTip />
                <p className="text">{t('top_tip')}</p>
            </div>
            <div className="bg-box"></div>
            <div className="content-box-container">
                <div className="content-box">
                    <div className={`kv-box`}>
                        <div className="kv-launch-time">{t('launchTime')}</div>
                        <div className="kv-title">{t('title')}</div>
                        <div className="kv-desc">{t('subTitle')}</div>
                    </div>
                    <div className="input-box">
                        <SubscribeInput />
                        <div className="icon">
                            <Upto off="$400" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
